<div class="container login">
  <div class="row">
    <div class="col-md-7 login-info">
      <!-- <img src="assets/img/meeting.jpg" alt="" class="login-info__back" /> -->
      <div class="login-info__social">
        <ol>
          <li><i class="bi bi-facebook"></i></li>
          <li><i class="bi bi-instagram"></i></li>
          <li><i class="bi bi-whatsapp"></i></li>
          <li><i class="bi bi-globe"></i></li>
        </ol>
      </div>
      <div class="login-info__desc">
        <img src="assets/img/logo-blanco.png" alt="Logo" class="logo-image" />
        <p class="description-text">
          La herramienta ideal para llevar tu <br />restaurante hacia el éxito
        </p>
      </div>
    </div>
    <div class="form-cont col-md-5">
      <div class="login-form">
        <img src="assets/img/logo-naranja.png" alt="" />
        <div class="login-form__cont d-flex">
          <h3>REGISTRARSE</h3>
          <form [formGroup]="myForm" (submit)="createCompany()">
            <div class="mb-5 form-group">
              <label for="exampleInputRuc" class="form-label">RUC</label>
              <input
                type="text"
                class="form-control"
                formControlName="comDocument"
                name="comDocument"
                id="exampleInputRuc"
                aria-describedby="emailHelp"
                [(ngModel)]="rucToCheck"
                (change)="verifyDocument()"
              />
            </div>
            <div
              *ngIf="
                myForm.get('idCompany')?.errors &&
                myForm.get('idCompany')?.dirty
              "
            >
              <div
                class="invalid-feedback"
                *ngIf="myForm.get('idCompany')?.hasError('required')"
              >
                Por favor ingrese su Ruc.
              </div>
            </div>
            <div class="mb-5 form-group">
              <label for="exampleInputRz" class="form-label">Razón Social</label>
              <input
                type="text"
                class="form-control"
                formControlName="comName"
                name="comName"
                id="exampleInputRz"
                aria-describedby="emailHelp"
              />
            </div>
            <div
              *ngIf="
                myForm.get('comName')?.errors &&
                myForm.get('comName')?.dirty
              "
            >
              <div
                class="invalid-feedback"
                *ngIf="myForm.get('comName')?.hasError('required')"
              >
                Por favor ingrese su Razón Social.
              </div>
            </div>
            <div class="mb-5 form-group">
              <label for="exampleInputName" class="form-label">Nombre</label>
              <input
                type="text"
                formControlName="useName"
                class="form-control"
                name="useName"
                id="exampleInputName"
                aria-describedby="NameHelp"
              />
            </div>
            <div
              *ngIf="
                myForm.get('useName')?.errors && myForm.get('useName')?.dirty
              "
            >
              <div
                class="invalid-feedback"
                *ngIf="myForm.get('useName')?.hasError('required')"
              >
                Por favor ingrese su email.
              </div>
            </div>

            <div class="mb-5 form-group">
              <label for="exampleInputLastName" class="form-label"
                >Apellido</label
              >
              <input
                type="text"
                formControlName="useLastName"
                class="form-control"
                name="useLastName"
                id="exampleInputLastName"
                aria-describedby="emailHelp"
              />
            </div>
            <div
              *ngIf="
                myForm.get('useLastName')?.errors &&
                myForm.get('useLastName')?.dirty
              "
            >
              <div
                class="invalid-feedback"
                *ngIf="myForm.get('useLastName')?.hasError('required')"
              >
                Por favor ingrese su apellido.
              </div>
            </div>

            <div class="mb-5 form-group">
              <label for="exampleInputEmail1" class="form-label">Correo</label>
              <input
                type="email"
                formControlName="useEmail"
                class="form-control"
                name="useEmail"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
              />
            </div>
            <div
              *ngIf="
                myForm.get('useEmail')?.errors && myForm.get('useEmail')?.dirty
              "
            >
              <div
                class="invalid-feedback"
                *ngIf="myForm.get('useEmail')?.hasError('required')"
              >
                Por favor ingrese su email.
              </div>
            </div>

            <div class="mb-5 form-group">
              <label for="exampleInputPassword1" class="form-label"
                >Contraseña</label
              >
              <input
                type="password"
                formControlName="password"
                name="password"
                class="form-control"
                id="exampleInputPassword1"
              />
            </div>
            <div
              *ngIf="
                myForm.get('password')?.errors && myForm.get('password')?.dirty
              "
            >
              <div
                class="invalid-feedback"
                *ngIf="myForm.get('password')?.hasError('required')"
              >
                Por favor ingrese su contraseña.
              </div>
            </div>

            <!-- <div class="col-md-6">
              <label for="useState" class="form-label">Estado</label>
              <div class="col-md-12">
                <select
                  class="form-select"
                  id="useState"
                  name="useState"
                  id="useState"
                  aria-label="Default select example"
                  formControlName="useState"
                >
                  <option selected value="">---Seleccionar---</option>
                  <option
                    *ngFor="let state of listState"
                    value="{{ state.value }}"
                  >
                    {{ state.name }}
                  </option>
                </select>
              </div>
            </div> -->
            <!-- <div class="mb-5 form-group">
              <label for="roles" class="form-label">Rol</label>
              <select
                class="form-select"
                name="roles"
                id="roles"
                aria-label="Default select example"
                formControlName="roles"
              >
                <option selected value="">---Seleccionar---</option>
                <option *ngFor="let rol of listUserRole" value="{{ rol.role }}">
                  {{ rol.name }}
                </option>
              </select>
            </div> -->
            <!-- </div> -->

            <!--<div class="mb-5 form-group">
              <label for="location" class="form-label">Locación</label>
              <select
                class="form-select"
                name="location"
                id="location"
                formControlName="location"
                aria-label="Default select example"
              >
                <option selected value="">---Seleccionar---</option>
                <option
                  *ngFor="let loc of location"
                  value="{{ loc.idLocation }}"
                >
                  {{ loc.locName }}
                </option>
              </select>
            </div>
            <div
              *ngIf="
                myForm.get('idLocation')?.errors &&
                myForm.get('idLocation')?.dirty
              "
            >
              <div
                class="invalid-feedback"
                *ngIf="myForm.get('idLocation')?.hasError('required')"
              >
                Por favor ingrese la locación.
              </div>
            </div>-->
            <div class="login-form__links">
              <button type="submit" class="btn btn-primary">REGISTRARSE</button>

              <a routerLink="/login">Volver al Login</a>
            </div>
          </form>
        </div>
      </div>
      <div class="decoration"></div>
    </div>
  </div>
</div>
